import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { useDashboard } from 'hooks/useDashboardState'
import { getDashboardByReportId } from 'features/liveReport/asyncThunks'

const useRetrieveDashboard = (id: string) => {
  const dispatch = useAppDispatch()

  const { status, dashboardData, rowHeight, statusCode } = useDashboard()

  useEffect(() => {
    dispatch(getDashboardByReportId({ id }))
  }, [dispatch, id])

  return { status, dashboardData, rowHeight, statusCode }
}

export default useRetrieveDashboard
